module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_9.f69fe949.png";